import { ACTION_APPROVE, ACTION_CANCEL, ACTION_CANCEL_APPROVE, ACTION_CANCEL_REFUSE, ACTION_CANCEL_SUBMIT, ACTION_REFUSE, ACTION_REINSTATE, ACTION_RETRACT } from "./constants";

export function isHourSubmissionDeadlineRequired(action) {
  return action === ACTION_CANCEL_SUBMIT || action === ACTION_RETRACT;
}

export function isShiftStartSubmissionDeadlineRequired(action) {
  return action === ACTION_APPROVE || action === ACTION_REFUSE || action === ACTION_CANCEL_APPROVE || action === ACTION_CANCEL_REFUSE;
}

export function isTwoMonthsFromShiftStartSubmissionDeadlineRequired(action) {
  return action === ACTION_CANCEL || action === ACTION_REINSTATE;
}